import { render } from "./HistorialUnidades.vue?vue&type=template&id=9c0ea06e&scoped=true"
import script from "./HistorialUnidades.vue?vue&type=script&lang=js"
export * from "./HistorialUnidades.vue?vue&type=script&lang=js"

import "./HistorialUnidades.vue?vue&type=style&index=0&id=9c0ea06e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0ea06e"]])

export default __exports__